export default "__VITE_ASSET__CkcdE5L8__"